import { createEntitySlice } from "../firestoreModuleUtils/slice";
import { MessageTabOrder } from "./records";

const slice = createEntitySlice<MessageTabOrder>({ name: "messageTabOrders" });

export const reducer = slice.reducer;
export const actions = slice.actions;
